// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".innerBorder[data-v-0604900c] {\n  border: 2px solid #ffffff;\n}", ""]);
// Exports
module.exports = exports;
